import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  InstagramBrandIcon,
  MailBrandIcon,
  YoutubeBrandIcon,
} from "../components/AboutContactBrandIcons";
import "./AboutPage.css";

const CONTACT_LINKS = {
  email: "info@nature4d.com",
  instagram: "https://www.instagram.com/nature4d/",
  youtube: "https://www.youtube.com/@naturex4D",
};

/** Files in `public/assets/` — missing images are skipped. */
const PHOTOGRAPHER_ASSETS = [
  { file: "photographer_01.jpg", alt: "Sina photographing outdoors" },
  { file: "photographer_02.jpg", alt: "Behind the camera in the field" },
  { file: "photographer_03.jpg", alt: "On location" },
];

function RailPhoto({ file, alt }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <figure className="about-rail-photo">
      <img
        src={`/assets/${file}`}
        alt={alt}
        loading="lazy"
        decoding="async"
        onError={() => setVisible(false)}
      />
    </figure>
  );
}

export default function AboutPage() {
  return (
    <div className="about">
      <div className="about-inner">
        <section className="about-split" aria-labelledby="about-heading">
          <div className="about-split-main">
            <p className="about-eyebrow">About</p>
            <h1 id="about-heading" className="about-headline">
              Behind the work
            </h1>

            <div className="about-prose">
              <p>
                Photography started for me as a hobby more than ten years ago—
                something to reach for after long days of thinking in abstractions.
                I have a background in physics, and that training still shows up in
                how I look at the world: patience for small signals, attention to
                light and pattern, and a stubborn wish to understand what is
                actually in front of me—not only what I expect to see.
              </p>
              <p>
                Out of that grew a real pull toward the natural world. I spend as
                much time as I can outside, watching wildlife, reading weather and
                terrain, and trying to photograph what it felt like to be there.
                Wild animals and wild places are what I keep coming back to.
              </p>
              <p>
                Thank you for being here. If any of these images slow you down for
                a moment, they will have done their job.
              </p>
              <p className="about-signoff">— Sina</p>
            </div>
          </div>

          <aside
            className="about-split-rail"
            aria-label="Photographer photographs"
          >
            {PHOTOGRAPHER_ASSETS.map(({ file, alt }) => (
              <RailPhoto key={file} file={file} alt={alt} />
            ))}
          </aside>
        </section>

        <section className="about-contact" id="contact" aria-labelledby="contact-heading">
          <h2 id="contact-heading" className="about-contact-title">
            Contact
          </h2>
          <p className="about-contact-lede">
            Prints, licensing, or a conversation about a project—reach out anytime.
          </p>
          <ul className="about-contact-links">
            <li>
              <a
                className="about-contact-link"
                href={`mailto:${CONTACT_LINKS.email}`}
              >
                <MailBrandIcon className="about-contact-icon" />
                <span>{CONTACT_LINKS.email}</span>
              </a>
            </li>
            <li>
              <a
                className="about-contact-link"
                href={CONTACT_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramBrandIcon className="about-contact-icon" />
                <span>Instagram </span>
              </a>
            </li>
            <li>
              <a
                className="about-contact-link"
                href={CONTACT_LINKS.youtube}
                target="_blank"
                rel="noopener noreferrer"
              >
                <YoutubeBrandIcon className="about-contact-icon" />
                <span>YouTube </span>
              </a>
            </li>
          </ul>
        </section>

        <p className="about-footer-link">
          <Link to="/portfolio">Browse the portfolio →</Link>
        </p>
      </div>
    </div>
  );
}
